module.exports = __webpack_public_path__ + "static/media/MuhammadFaisalImage(B).abad1d88.JPG";